<template>
  <div v-if="company && vacancy && candidate" class="info-block">
    <div class="info-row">
      <span class="info-row__label">{{ $t('company') }}</span>
      <a :href="companyUrl" class="info-row__value info-row__value--link">{{ company.title }}</a>
    </div>
    <div class="info-row">
      <span class="info-row__label">{{ $t('vacancy') }}</span>
      <a :href="vacancyUrl" target="_blank" class="info-row__value info-row__value--link">{{ vacancy.title }}</a>
    </div>
  </div>
</template>

<script>
import useRoom from '@/compositions/useRoom';
import useHomeUrl from '@/compositions/useHomeUrl';
import { computed } from '@vue/composition-api';

export default {
  name: 'VideoRoomEnterCandidate',
  setup() {
    const { existingRoom } = useRoom();
    const { homeUrl } = useHomeUrl();

    const candidate = computed(() => existingRoom.value?.candidate);
    const vacancy = computed(() => existingRoom.value?.vacancy);
    const company = computed(() => existingRoom.value?.company);

    return {
      candidate,
      vacancy,
      company,
      vacancyUrl: computed(() => `${homeUrl}/company/${company.value?.id}/vacancy/${vacancy.value?.id}`),
      companyUrl: computed(() => `${homeUrl}/company/${company.value?.id}`),
    };
  },
};
</script>

<style lang="scss" scoped>
.info-block {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  &__label {
    font-size: 0.7rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #9BAEC4;
  }

  &__value {
    font-size: 0.9375rem;
    font-weight: 400;
    color: #1A1A2E;

    &--link {
      color: #0A82D9;
      text-decoration: none;
      transition: color 0.15s ease;

      &:hover {
        color: #0068B8;
        text-decoration: underline;
      }
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
company: Company
vacancy: Vacancy
</i18n>

<i18n locale="ru" lang="yaml">
company: Компания
vacancy: Вакансия
</i18n>
